import { useTranslation } from 'react-i18next';
import { ColumnDef } from '@tanstack/react-table';
import { TableCell } from '@anytag/shared-atoms';
import { usePostDetailsParam } from '@anytag/shared-hooks';
import { YoutubeAnalyticsComparePostsSortOrder } from '@anytag/graphql';
import { convertDurationToHhMmSs, formatIntNumber } from '@anytag/shared-utils';
import { InfluencerYoutubeCompareVideosType } from '../types';

export const useYoutubeCompareVideosTable = () => {
  const { t } = useTranslation();
  const { setPostDetailsParam } = usePostDetailsParam();

  const columns: ColumnDef<InfluencerYoutubeCompareVideosType>[] = [
    {
      accessorKey: 'videos',
      meta: { sticky: true },
      header: t<string>('HeaderColumn.Videos'),
      cell: ({ row }) => (
        <TableCell.Post
          title={row.original.title || ''}
          thumbnail={row.original.thumbnail || ''}
          onClick={() => setPostDetailsParam(row.original.id)}
        />
      )
    },
    {
      accessorKey: 'postDate',
      header: t<string>('HeaderColumn.Post date'),
      cell: ({ row }) => <TableCell.Date className="min-w-20" value={row.original.postDate} />
    },
    {
      accessorKey: 'views',
      header: t<string>('HeaderColumn.View'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.views)} />
    },
    {
      accessorKey: 'likes',
      header: t<string>('HeaderColumn.Like'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.likes)} />
    },
    {
      accessorKey: 'dislikes',
      header: t<string>('HeaderColumn.Dislike'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.dislikes)} />
    },
    {
      accessorKey: 'comments',
      header: t<string>('HeaderColumn.Comment'),
      meta: { align: 'right' },
      cell: ({ row }) => <TableCell.Number value={formatIntNumber(row.original.comments)} />
    },
    {
      accessorKey: 'duration',
      header: t<string>('HeaderColumn.Play Time'),
      meta: { align: 'right', sortField: YoutubeAnalyticsComparePostsSortOrder.DURATION },
      cell: ({ row }) => <TableCell.Number value={convertDurationToHhMmSs(row.original.duration)} />
    }
  ];

  return { columns };
};
